import { apiRequest } from "../index";
import axios from "axios";


export const getAllLanguageFiles = async (platform) => {
  return apiRequest(`/api/admin/languages/files?platform=${platform}`, "GET");
};


export const getLanguageFileById = async (fileId) => {
  return apiRequest(`/api/admin/languages/files/${fileId}`, "GET");
};

export const uploadLanguageFile = async (formData) => {
  return apiRequest("/api/admin/languages/upload", "POST", formData, true);
};

export const downloadLanguageFile = async (fileId) => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/languages/files/${fileId}/download`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`, 
    },
  });
  return response.data;
};


export const deleteLanguageFile = async (fileId) => {
  return apiRequest(`/api/admin/languages/files/${fileId}`, "DELETE");
};

export const getLanguageFileContent = async (languageCode) => {
  return apiRequest(`/api/admin/languages/content/${languageCode}`, "GET");
};
